<template>
  <div>
    <p>{{ $route.data }}</p>
    <ui-button type="primary" @click.native="$router.push('/index')">{{
      $t("backToHome")
    }}</ui-button>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
